module.exports = __webpack_public_path__ + "img/phone-and-buds.eb882bd5.png";